import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';
import { IStateProvider, IUrlRouterProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.reportsv2').config(config);

config.$inject = ['$stateProvider', '$urlRouterProvider'];

function config(
  $stateProvider: IStateProvider,
  $urlRouterProvider: IUrlRouterProvider
) {
  $stateProvider.state(STATE_MAPPINGS.reports, {
    url: 'reports',
    params: { title: 'Reports' },
    templateUrl: 'Client/runner.reportsv2/runner.reportsv2.tmpl.html',
    controller: RunnerReportsV2Controller,
    controllerAs: 'ctrl'
  });

  $urlRouterProvider.when('/reportsv2', '/reports');
}

class RunnerReportsV2Controller {
  static $inject = ['brandingService', 'pubsubService', '$scope', '$state'];

  helpUri: string;
  subscriberId = 'ReportsV2Controller';

  constructor(
    private brandingService: SharedAngular.BrandingService,
    private pubsubService: SharedAngular.PubSubService,
    private $scope: angular.IScope,
    private $state: angular.ui.IStateService
  ) {
    this.helpUri = this.brandingService.getBrandedHelpUri(
      'https://help.flowingly.net/getting-started/how-do-i-run-a-report'
    );

    this.pubsubService.subscribe(
      'WORKFLOW_REPORT_CLICKED',
      (eventName: string, flowModelId: Guid) => {
        this.$state.go(STATE_MAPPINGS.report, { flowModelId });
      },
      this.subscriberId
    );
    this.$scope.$on('$destroy', () => {
      this.pubsubService.unsubscribeAll(this.subscriberId);
    });
  }
}
